import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import BigNumber from 'bignumber.js';

@Directive({
  selector: '[appLimitDecimal]'
})
export class LimitDecimalDirective {
  private lastValue = ''

  @Input() appLimitDecimal = 0;

  constructor(private elementRef: ElementRef) {
    this.lastValue = this.elementRef.nativeElement.value;
  }

  @HostListener('input', ['$event'])
  input(e: Event) {
    const value = this.elementRef.nativeElement.value
    if (this.inputing(value) || this.checkDecimals(value, this.appLimitDecimal)) {
      this.lastValue = value;
    } else {
      this.elementRef.nativeElement.value = this.lastValue;
      e.stopPropagation();
    }
  }

  @HostListener('focus')
  change() {
    this.lastValue = this.elementRef.nativeElement.value;
  }

  private checkDecimals(value: any, decimal: number) {
    return new BigNumber(value).truncate(decimal).toString() === value.toString();
  }

  private endWithDot(str: string) {
    return str.indexOf('.') === str.length - 1;
  }

  private endWithZero(str: string) {
    return str.charAt(str.length - 1) === '0';
  }

  private inputing(value: string) {
    return value === '' || this.endWithDot(value) || this.endWithZero(value)
  }
}
